/**
 * Created by JIA on 2022/1/19.
 */

import _ from "lodash";
import { t } from "../../../../i18n";
import { AzureEnums, buildZeroReviewResult, buildZeroReviewResultForEn, i18nKey } from "../SpeechCommonHelper";
import Constants from "../../../../config/Constants";

//region [Azure Result Process]
/**
 * azure 默认会分词,需要给每个字加上空格防止这种情况
 * 今 天 天 气 怎 么 样
 * @param interObj
 * @param nativeSetReferenceText
 */
const handleTextForAzure = (interObj, nativeSetReferenceText) => {
    const { referenceText } = interObj;
    interObj.orgReferenceText = referenceText;
    if (interObj.lang === Constants.SPEECH_LANG.en) {
        nativeSetReferenceText(referenceText);
    } else {
        const finalText = _.join(Array.from(referenceText), " ");
        // console.log(finalText);
        nativeSetReferenceText(finalText);
    }
};


const handleAzureResult = (internalInfoObj, jsonResult) => {
    //https://docs.microsoft.com/zh-cn/azure/cognitive-services/speech-service/rest-speech-to-text
    //first see if request is success or not
    //Please Note the return obj prop is first letter upper case
    let returnObj = {
        shouldResolve: false,
        rejectMessage: "",
        result: {},
    };
    const isEnCase = (internalInfoObj.lang === Constants.SPEECH_LANG.en);
    let notCompleted = true;
    if (jsonResult.RecognitionStatus) {
        switch (jsonResult.RecognitionStatus) {
            case AzureEnums.RecognitionStatus.Success:
                //detect the NBest part, it is an array
                const nbPart = jsonResult.NBest;
                if (nbPart && _.isArray(nbPart) && nbPart.length > 0) {
                    let newReturnObj = {
                        passed: false,
                        resultWordArray: [],
                        referenceTextWordArray: [],
                        pronScore: 0,
                        accuracyScore: 0,
                        fluencyScore: 0,
                        completionScore: 0,
                        wordResultArray: [],
                        notPassedWordIndexDic: {}, // the key is index, the value is word item
                        rawResult: jsonResult,
                    };
                    const targetNB = nbPart[0];
                    //Confidence	:	0.9137394428253174
                    // Lexical	:	白 日 依 山 尽 黄 河 入 海 流
                    // ITN	:	白 日 依 山 尽 黄 河 入 海 流
                    // MaskedITN	:	白日依山尽黄河入海流
                    // Display	:	白日依山尽黄河入海流。
                    // PronScore	:	100  //指示给定语音的发音质量的总体分数。 这是通过AccuracyScore FluencyScore和CompletenessScore权重计算得出的。
                    // AccuracyScore	:	  //指示给定语音的读音准确性的分数。
                    // FluencyScore	:	100  //指示给定语音的熟练的分数。
                    // CompletionScore	:	100 //该分数指示给定语音的完整性，方法是计算要向整个输入的单词的比率。
                    // ErrorType	:	 //此值指示与相对应的字是省略、插入还是不正确ReferenceText。 可能的值None为（表示此词上无错误） Omission、 Insertion和Mispronunciation。

                    newReturnObj.passed = targetNB.AccuracyScore > 80;
                    newReturnObj.resultWordArray = targetNB.Lexical.split(" "); //should we compare this?
                    newReturnObj.referenceTextWordArray = internalInfoObj.referenceText.split("");
                    newReturnObj.pronScore = targetNB.PronScore;
                    newReturnObj.accuracyScore = (targetNB.AccuracyScore * 0.8 + targetNB.PronScore * 0.3 + targetNB.FluencyScore * 0.1 + targetNB.CompletenessScore * 0.8) / 2;
                    newReturnObj.fluencyScore = targetNB.FluencyScore;
                    newReturnObj.completionScore = targetNB.CompletenessScore;
                    newReturnObj.errorType = targetNB.ErrorType;

                    //the en case, azure total accuracyScore is not good if you do first syll right next syll wrong, we use all syll accuryScore avg instead
                    let syllAvgAccuracyScore = 0;
                    let passedWordCount = 0;
                    //go for inner
                    if (targetNB && _.isArray(targetNB.Words) && targetNB.Words.length > 0) {
                        _.each(targetNB.Words, (item, index) => {
                            if (isEnCase) {
                                //"Word":"what"
                                // "Offset":15000000
                                // "Duration":5500000
                                // "Confidence":0
                                // "AccuracyScore":98
                                // "ErrorType":"None"
                                // "Syllables":[
                                // 0:{
                                // "Syllable":"waat"
                                // "Grapheme":"what"
                                // "AccuracyScore":98
                                // }
                                // ]
                                // "Phonemes":[
                                // 0:{
                                // "Phoneme":"w"
                                // "AccuracyScore":93
                                // }
                                let wordSyllAvgScore = _.sum(_.map(item.Syllables, s=>s.AccuracyScore))/_.size(item.Syllables);
                                if (item.ErrorType !== AzureEnums.WordErrorType.None) {
                                    wordSyllAvgScore = 0;
                                }
                                newReturnObj.wordResultArray.push({
                                    word: item.Word,
                                    pronScore: item.PronScore,
                                    accuracyScore: wordSyllAvgScore, //item.AccuracyScore,
                                    errorType: item.ErrorType,
                                    phonemes: item.Phonemes, //just copy here
                                    flag: item.ErrorType === AzureEnums.WordErrorType.None && item.AccuracyScore > 60,
                                });

                                if (item.ErrorType === AzureEnums.WordErrorType.None) {
                                    passedWordCount += 1;
                                } else {
                                    newReturnObj.notPassedWordIndexDic[_.toString(index)] = {
                                        word: item.Word,
                                        pronScore: item.PronScore,
                                        accuracyScore: wordSyllAvgScore,
                                        errorType: item.ErrorType,
                                        phonemes: item.Phonemes, //just copy here
                                    };
                                }
                                syllAvgAccuracyScore += wordSyllAvgScore;
                            } else {
                                //Word	:	白
                                // PronScore	:	100
                                // AccuracyScore	:	100
                                // ErrorType	:	None
                                // Offset	:	14900000
                                // Duration	:	6000000
                                // 	Phonemes		[3] // no need use this for now, the min unit for us is word by now

                                const buildItemForChar = (charItem, char) => {
                                    newReturnObj.wordResultArray.push({
                                        word: char ? char : charItem.Word,
                                        pronScore: charItem.PronScore,
                                        accuracyScore: charItem.AccuracyScore,
                                        errorType: charItem.ErrorType,
                                        phonemes: charItem.Phonemes, //just copy here
                                        flag: charItem.ErrorType === AzureEnums.WordErrorType.None && charItem.AccuracyScore > 60,
                                    });

                                    if (item.ErrorType === AzureEnums.WordErrorType.None) {
                                        passedWordCount += 1;
                                    } else {
                                        newReturnObj.notPassedWordIndexDic[_.toString(index)] = {
                                            word: item.Word,
                                            pronScore: item.PronScore,
                                            accuracyScore: item.AccuracyScore,
                                            errorType: item.ErrorType,
                                            phonemes: item.Phonemes, //just copy here
                                        };
                                    }
                                };

                                //有时仍会遇到 5 7 0 m l => 5,7,0m,l的情况
                                if (item.Word.length > 1) {
                                    _.each(Array.from(item.Word), char => {
                                        buildItemForChar(item, char);
                                    });
                                } else {
                                    buildItemForChar(item);
                                }
                            }
                        });

                        if (isEnCase) {
                            syllAvgAccuracyScore = syllAvgAccuracyScore/_.size(targetNB.Words);
                            newReturnObj.accuracyScore = _.ceil(syllAvgAccuracyScore, 0);
                        }
                    }

                    //we will check the final pass word count and see if you are passed
                    newReturnObj.passed = newReturnObj.accuracyScore > 80 && passedWordCount === newReturnObj.wordResultArray.length;
                    newReturnObj.passedWordCount = passedWordCount;
                    newReturnObj.wholeWordCount = newReturnObj.wordResultArray.length;

                    //DebugLogger.log(newReturnObj);
                    returnObj.result = newReturnObj;
                    returnObj.shouldResolve = true;
                    notCompleted = false;
                }

                break;
            case AzureEnums.RecognitionStatus.Error: //识别服务遇到内部错误，无法继续。 如果可能，请重试。
                returnObj.shouldResolve = true;
                returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
                notCompleted = false;
                break;
            case AzureEnums.RecognitionStatus.BabbleTimeout: //音频流的开始仅包含噪音，并且服务在等待语音时超时。
            case AzureEnums.RecognitionStatus.InitialSilenceTimeout: //音频流的开始仅包含静音，并且服务在等待语音时超时。
            case AzureEnums.RecognitionStatus.NoMatch: //在音频流中检测到语音，但没有匹配目标语言的字词。 通常表示识别语言不同于讲话用户所用的语言。
                // returnObj.shouldResolve = false;
                // returnObj.rejectMessage = t(`${i18nKey}:PleaseSpeak`);
                let returnObjZ = isEnCase ? buildZeroReviewResultForEn(internalInfoObj.orgReferenceText, internalInfoObj.syllableArray) : buildZeroReviewResult(internalInfoObj.orgReferenceText, internalInfoObj.syllableArray);
                returnObj.result = returnObjZ;
                returnObj.shouldResolve = true;
                notCompleted = false;
                break;
            // case AzureEnums.RecognitionStatus.NoMatch: //在音频流中检测到语音，但没有匹配目标语言的字词。 通常表示识别语言不同于讲话用户所用的语言。
            //     returnObj.shouldResolve = false;
            //     returnObj.rejectMessage = t(`${i18nKey}:NotChinese`);
            //     notCompleted = false;
            //     break;
            default:
                break;
        }
        if (notCompleted) {
            returnObj.shouldResolve = false;
            returnObj.rejectMessage = t(`${i18nKey}:ServerError`);
        }
    }
    return returnObj;
};
//endregion
export { handleTextForAzure, handleAzureResult };
